import { render, staticRenderFns } from "./FeatureValuesEdit.vue?vue&type=template&id=96a86f7a&scoped=true&"
import script from "./FeatureValuesEdit.vue?vue&type=script&lang=js&"
export * from "./FeatureValuesEdit.vue?vue&type=script&lang=js&"
import style0 from "./FeatureValuesEdit.vue?vue&type=style&index=0&id=96a86f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a86f7a",
  null
  
)

export default component.exports